import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { hasShopifyInstallation } from '../../lib/services/shopify/shopifyApi';

export function ShopifyGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuthStore();

  if (!hasShopifyInstallation(user)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
